import { useEffect, useState } from 'react';
import { noActivity, type TrackActivity } from './activity.js';
import { fetchContactCards, type ContactCard } from './api.js';
import { dealerPhoneHref } from './dealers.js';

function contactMapUrl(card: ContactCard): string | null {
  if (card.latitude === null || card.longitude === null) return null;
  const url = new URL('https://yandex.ru/maps/');
  url.searchParams.set('ll', `${card.longitude},${card.latitude}`);
  url.searchParams.set('pt', `${card.longitude},${card.latitude},pm2rdm`);
  url.searchParams.set('z', '14');
  return url.toString();
}

export function OurContactsScreen({ track = noActivity, title = 'Наши контакты' }: {
  track?: TrackActivity;
  title?: string;
}) {
  const [items, setItems] = useState<ContactCard[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    fetchContactCards()
      .then((cards) => { if (!cancelled) setItems(cards); })
      .catch((reason: unknown) => {
        if (!cancelled) setError(reason instanceof Error ? reason.message : 'Не удалось загрузить контакты.');
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [attempt]);

  return <section className="contacts-screen" aria-labelledby="contacts-title">
    <h1 className="feature-title" id="contacts-title">{title}</h1>
    {loading ? <p className="station-search__message" role="status">Загружаем контакты…</p> : null}
    {error ? <div role="alert">
      <p className="station-search__message station-search__message--error">{error}</p>
      <button className="station-results__more" type="button" onClick={() => setAttempt((value) => value + 1)}>Повторить загрузку</button>
    </div> : null}
    {!loading && !error && items.length === 0 ? <p className="station-search__message">Контакты пока не добавлены.</p> : null}
    {!loading && !error && items.length > 0 ? <ul className="contact-cards">
      {items.map((card) => <ContactCardView key={card.id} card={card} track={track} />)}
    </ul> : null}
  </section>;
}

function ContactCardView({ card, track }: { card: ContactCard; track: TrackActivity }) {
  const phoneHref = dealerPhoneHref(card.phone);
  const mapUrl = contactMapUrl(card);
  const openMap = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const webApp = window.WebApp;
    if (webApp?.initData && webApp.openLink && mapUrl) {
      event.preventDefault();
      webApp.openLink(mapUrl);
    }
  };
  return <li className="station-card contacts-card">
    <p className="contacts-card__eyebrow">ТОНАР</p>
    <h2>{card.title}</h2>
    {card.address ? <p className="contacts-card__text">{card.address}</p> : null}
    <strong className="contacts-card__phone">{card.phone}</strong>
    <div className="station-card__actions">
      {phoneHref ? <a href={phoneHref} onClick={() => track('our_contacts', 'phone_click', String(card.id))}>Позвонить</a> : null}
      {mapUrl ? <a href={mapUrl} onClick={(event) => {
        track('our_contacts', 'map_click', String(card.id));
        openMap(event);
      }}>На карте</a> : null}
    </div>
  </li>;
}
